/* @flow */
import {param, deparam} from './query-parameters';
import {hasWorkingUrl} from './has-working-url';

export const Routing = {
    param,
    deparam,
    hasWorkingUrl,
};
